import { render } from "./PagoProveedor.vue?vue&type=template&id=706a81fe&scoped=true"
import script from "./PagoProveedor.vue?vue&type=script&lang=js"
export * from "./PagoProveedor.vue?vue&type=script&lang=js"

import "./PagoProveedor.vue?vue&type=style&index=0&id=706a81fe&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\rotcen_frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-706a81fe"]])

export default __exports__